var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_515_14555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14887 22.3806L3.07184 3.52305C2.67413 2.04583 4.01467 0.687208 5.49709 1.06508L22.7283 5.45734C25.6429 6.20029 27.6826 8.82516 27.6826 11.833C27.6826 13.6731 26.912 15.4292 25.5578 16.675L16.6719 24.8501C15.7142 25.7312 14.4603 26.2202 13.159 26.2202C10.8129 26.2202 8.75878 24.646 8.14887 22.3806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14887 22.3806L3.07184 3.52305C2.67413 2.04583 4.01467 0.687208 5.49709 1.06508L22.7283 5.45734C25.6429 6.20029 27.6826 8.82516 27.6826 11.833C27.6826 13.6731 26.912 15.4292 25.5578 16.675L16.6719 24.8501C15.7142 25.7312 14.4603 26.2202 13.159 26.2202C10.8129 26.2202 8.75878 24.646 8.14887 22.3806Z",
    stroke: "#303336",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_515_14555",
    x: 0,
    y: 0,
    width: 30.6826,
    height: 31.2202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_515_14555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_515_14555",
    result: "shape"
  })))));
};
export default SvgCursor;